import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
// import { history } from "../../../index"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from 'react-router-dom'
import * as Actions from "../../../store/actions"
import { ModalBody, ModalFooter, ModalHeader, Button, Modal } from 'reactstrap'
import { RadioButtonChecked, RadioButtonUnchecked } from "@material-ui/icons"
import { IconButton } from '@material-ui/core';
import { ToastContainer, toast } from 'react-toastify';

const LoginBox = props => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [Email, setEmail] = useState("");
    const [Password, setPassword] = useState("");
    const [ErrorMsg, setErrorMsg] = useState("");
    const [Loading, setLoading] = useState(false);

    const [MultiFactorBoxOpen, setMultiFactorBoxOpen] = useState(false);
    const [MultiCode, setMultiCode] = useState("");
    const [MultiError, setMultiError] = useState("");

    const [RegionsData, setRegionsData] = useState([]);
    const [IsShowRegionsDialogOpen, setIsShowRegionsDialogOpen] = useState(false);
    const [ShowRegionHeading, setShowRegionHeading] = useState(false);
    const [ShowClinicsHeading, setShowClinicsHeading] = useState(false);
    const [SelectedRegionOrClinic, setSelectedRegionOrClinic] = useState("");

    const baseURL = useSelector(({ utils }) => utils.baseURL);


    async function checkForRegions() {
        setErrorMsg("")
        setLoading(true)


        dispatch(Actions.LoginProviderAction(Email, Password)).then((res) => {
            if (res) {
                // if (typeof res == "string") {
                    // setLoading(false)
                    // setErrorMsg(res)
                //     return
                // }
                if(res.status == 0){
                    setLoading(false)
                    setErrorMsg("Invalid user credentials, Account will be locked after 5 attempts. ")
                    return
                }
                if (!res.data || res.data?.length == 0) {
                    return submitHandler()
                }
                setRegionsData(res.data)
                setIsShowRegionsDialogOpen(true)
                setSelectedRegionOrClinic("");
                setShowClinicsHeading(false);
                setShowRegionHeading(false)

                res.data.forEach(value => {
                    if (value.isRegionOrClinic == 1) setShowRegionHeading(true);
                    if (value.isRegionOrClinic == 0) setShowClinicsHeading(true);

                });

                setLoading(false)
                setErrorMsg("")

            }
        })
    }



    async function loginHandler() {
        setErrorMsg("")
        setLoading(true)
        setIsShowRegionsDialogOpen(false)


        const adminDocterId = RegionsData.filter(x => x.clinicGroupItemId == SelectedRegionOrClinic)[0]?.adminDocterId

        dispatch(Actions.LoginAction(Email, Password, SelectedRegionOrClinic, adminDocterId, MultiCode,navigate)).then((res) => {
            if (res) {
                setLoading(false)
                setErrorMsg(res)
                setMultiError(res)
            }
        })
    }

    async function submitHandler() {
        setErrorMsg("")
        setLoading(true)
        setIsShowRegionsDialogOpen(false)
        const adminDocterId = RegionsData.filter(x => x.clinicGroupItemId == SelectedRegionOrClinic)[0]?.adminDocterId

        dispatch(Actions.MFACheckAction(Email, Password, SelectedRegionOrClinic, adminDocterId, MultiCode)).then((res) => {
            if (res) {
                setLoading(false)
                // setErrorMsg(res)

                if (typeof res == "string") {
                    setLoading(false)
                    setErrorMsg(res)
                    setMultiError(res)
                    return
                }
                if (res.status == 0 || res.status == 4 || res.status == 3) {
                    setErrorMsg(res.msg)
                    return
                }
                if (res.status == 1) {
                    loginHandler()
                    return
                }
                if (res.status == 2) {
                    toast.info(`Please check your cell phone for the passcode!`, {
                        position: "top-center",
                        autoClose: 4000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                        
                    });
                    setMultiFactorBoxOpen(true)
                    return
                }
            }
        })
    }

    function toggleModalOff() {
        setIsShowRegionsDialogOpen(false)
        setShowClinicsHeading(false)
        setShowRegionHeading(false)
    }


    if (MultiFactorBoxOpen) {
        return (
            <section className="login-box">
                <div className="logo-header">
                    <img
                        src={"/images/ptlogo.png"}
                    />
                </div>

                <div className="inputs-login">
                    <h2
                        style={{
                            fontSize: "23px",
                            color: "#348FE2",
                            fontWeight: "bold"
                        }}
                        className="MultiHeading">
                        Multi-Factor Authentication
                    </h2>
                    <h2
                        className="ConfirmationHeading"
                        style={{
                            fontSize: "12px",
                            fontWeight: "bold",
                            marginTop: "20px"
                        }}>
                        Please add your multi-factor code to complete the sign in
                    </h2>
                    <h2 className="smallH2"
                        style={{
                            fontWeight: "bold",
                            fontSize: "12px",
                            marginTop: "20px",
                            color: "#575958",
                        }}
                    >
                        A One-Time code has been sent to your registered email address
                    </h2>


                    <input
                        style={{ marginTop: "20px" }}
                        maxLength="6"
                        className="frmInput"
                        type="password"
                        placeholder="Please enter the code here* "
                        value={MultiCode}
                        onChange={(e) => setMultiCode(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                loginHandler()
                                // checkForRegions()
                            }
                        }}

                    />
                    <b className="ErrorMsg">{MultiError}</b>

                    <button
                        style={Loading ? { background: "grey" } : {}}
                        onClick={() => {
                            // checkForRegions()
                            // setMultiError("error")
                            loginHandler()

                        }}
                        className="SignInButton">
                        {
                            Loading ? "Loading..." : "Validate"
                        }
                    </button>
                    <span >

                        <h2 className="forget" style={{ cursor: "default" }}>
                            <span onClick={() => submitHandler()} style={{ cursor: "pointer" }}>Resend Code</span> <b> | </b> <span onClick={() => {
                                setMultiFactorBoxOpen(false)
                                setErrorMsg("")
                                setMultiError("")
                                setMultiCode("")
                            }} style={{ cursor: "pointer" }}>Go Back</span>
                        </h2>
                    </span>

                </div>
            </section>
        )
    }

    return (
        <section className="login-box">
            <div className="logo-header">
                <img
                    src={"/images/ptlogo.png"}
                />
            </div>
            <div className="inputs-login">
                <h2 className="userLoginH2">
                    User Login 
                </h2>

                <input
                    className="frmInput"
                    type="text"
                    placeholder="* Enter Email Here"
                    value={Email}
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {

                            checkForRegions()
                        }
                    }}

                />

                <input
                    className="frmInput"
                    placeholder="* Enter Password Here"
                    type="password"
                    value={Password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {

                            checkForRegions()
                        }
                    }}
                />
                <b className="ErrorMsg">{ErrorMsg}</b>
                <button
                    style={Loading ? { background: "grey" } : {}}
                    onClick={() => {
                        checkForRegions()
                        // setMultiFactorBoxOpen(true)
                    }}
                    className="SignInButton">
                    {
                        Loading ? "Loading..." : "Sign In"
                    }
                </button>


                <span onClick={() => props.Toggle()}>

                    <h2 className="forget">
                        forgot password?
                </h2>
                </span>


                <h2 className="dontHaveAccount">
                    Do not have an account yet?
                </h2>



                <a
                    href={`${baseURL}/therapist/#/create-account/25/?isFromMeeting=1`}
                    target="blank"
                >
                    <button className="RegisterButton">
                        Register Now
                    </button>
                </a>
            </div>

            {
                IsShowRegionsDialogOpen ? (
                    <>
                        <Modal centered isOpen={IsShowRegionsDialogOpen} toggle={() => toggleModalOff(false)} >
                            <ModalHeader toggle={() => toggleModalOff(false)}>
                                <span style={{ fontSize: "17px", color: "#3182ba" }}>
                                    Choose region or clinic
                               </span>
                            </ModalHeader>
                            <ModalBody>
                                <div style={{ width: "100%", height: "auto", }}>
                                    {
                                        ShowRegionHeading ? (
                                            <div style={{ color: "#3182ba", marginBottom: "15px" }}>
                                                Regions:
                                            </div>
                                        ) : null
                                    }
                                    {
                                        RegionsData?.map((value, index) => {
                                            if (value.isRegionOrClinic == 0) return

                                            return (
                                                <div key={index} style={{ height: "40px", width: "100%", background: "#f5f5f5", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px 10px" }}>
                                                    <span style={{ fontSize: "13px", color: "#707478" }}>{value.itemName} </span>
                                                    <IconButton
                                                        onClick={() => setSelectedRegionOrClinic(value.clinicGroupItemId)}
                                                    >

                                                        {
                                                            value.clinicGroupItemId == SelectedRegionOrClinic ? (
                                                                <RadioButtonChecked fontSize="small" color="primary" />
                                                            ) : (
                                                                <RadioButtonUnchecked fontSize="small" color="primary" />
                                                            )
                                                        }


                                                    </IconButton>
                                                </div>
                                            )
                                        })
                                    }

                                    {
                                        ShowClinicsHeading ? (
                                            <div style={{ color: "#3182ba", margin: "15px 0" }}>
                                                Clinics:
                                            </div>
                                        ) : null
                                    }
                                    {
                                        RegionsData?.map((value, index) => {
                                            if (value.isRegionOrClinic == 1) return

                                            return (
                                                <div key={index} style={{ height: "40px", width: "100%", background: "#f5f5f5", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px 10px" }}>
                                                    <span style={{ fontSize: "13px", color: "#707478" }}>{value.itemName} </span>
                                                    <IconButton
                                                        onClick={() => setSelectedRegionOrClinic(value.clinicGroupItemId)}

                                                    >
                                                        {
                                                            value.clinicGroupItemId == SelectedRegionOrClinic ? (
                                                                <RadioButtonChecked fontSize="small" color="primary" />
                                                            ) : (
                                                                <RadioButtonUnchecked fontSize="small" color="primary" />
                                                            )
                                                        }
                                                    </IconButton>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button disabled={!SelectedRegionOrClinic} color="primary" onClick={() => submitHandler()}>Next</Button>
                            </ModalFooter>
                        </Modal>

                    </>
                ) : null
            }
        </section>
    )
}

LoginBox.propTypes = {
    Toggle: PropTypes.func.isRequired,
}

export default LoginBox
